import axios from 'axios'

const baseURL = `${process.env.VUE_APP_API_URL}`

export const isUserLoggedIn = () => {
  return localStorage.getItem('USER_TOKEN')
}

export const getUserData = () => JSON.parse(localStorage.getItem('userData'))

export default {
  saveAccessToken(token) {
    localStorage.setItem('USER_TOKEN', token)
  },
  getAccessToken() {
    return localStorage.getItem('USER_TOKEN')
  },
  getMe() {
    try {
      return axios.get(`${baseURL}/accounts/me`)
    } catch (e) {
      throw e
    }
  },
  login(email, password) {
    try {
      return axios.post(`${baseURL}/accounts/sign-in`, { email, password })
    } catch (e) {
      throw e
    }
  },
  signup(data) {
    // return { ...data, token: 'true' }
    try {
      return axios.post(`${baseURL}/accounts/sign-up`, data)
    } catch (e) {
      throw e
    }
  },

  resetPassword(email) {
    try {
      return axios.post(`${baseURL}/accounts/reset-password`, { email })
    } catch (e) {
      throw e
    }
  },

  resetPasswordWithToken(token, data) {
    try {
      return axios.post(`${baseURL}/accounts/reset-password/${token}`, data)
    } catch (e) {
      throw e
    }
  },
}
